
const AddComment = () => {
  return (
    <span className="svg-icon">
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.4925 3C16.4925 2.175 15.825 1.5 15 1.5H3C2.175 1.5 1.5 2.175 1.5 3V12C1.5 12.825 2.175 13.5 3 13.5H13.5L16.5 16.5L16.4925 3ZM12.75 8.25H9.75V11.25H8.25V8.25H5.25V6.75H8.25V3.75H9.75V6.75H12.75V8.25Z" fill="#482982"/>
      </svg>
    </span>
  )
}

export default AddComment